import { Container } from "react-bootstrap"
import SignupForm from "./../components/signupForm"

const SignUpPage = () => {
  return (
    <Container>
      <SignupForm />
    </Container>
  )
}

export default SignUpPage
